import { BasketActionTypes } from '@store/basket/basket-actions';

export const initialState = {
  price: 0,
  payablePrice: 0,
  discountPrice: 0,
  routeKey: undefined,
  userId: undefined,
  details: {},
  basketCount: 0,
  clientSuggestedType: '1',
  clientSuggestedTime: undefined,
  clientSuggestedRange: undefined,
  recipients: {
    '1': '',
  },
  recipientsValidation: false,
  recipientsError: false,
  storeBasketLoading: false,
  productId: undefined,
  loading: true,
};

function basketReducer(state = initialState, action: any) {
  switch (action.type) {
    case BasketActionTypes.SET_BASKET_INFO: {
      let basketInfo = {};
      let basketCount = 0;
      if (action?.data?.basket_details && action?.data?.basket_details.length) {
        action?.data?.basket_details.map((item: any) => {
          basketCount += parseInt(item.quantity);
          basketInfo = Object.assign({}, basketInfo, {
            [item?.orderable_route_key]: item.quantity,
          });
        });
      }

      return {
        ...state,
        price: Number(action?.data?.price),
        payablePrice: Number(action?.data?.payable_price),
        discountPrice: Number(action?.data?.discount_price),
        routeKey: action?.data?.route_key,
        userId: action?.data?.user_id,
        details: action?.data?.basket_details,
        basketCount: basketCount,
        basketInfo: basketInfo,
        loading: false,
      };
    }
    case BasketActionTypes.RESET_BASKET_INFO:
      return {
        ...initialState,
        routeKey: state.routeKey,
      };

    case BasketActionTypes.ADD_AND_INCREMENT_ITEM_TO_BASKET:
      return {
        ...state,
        productId: action?.data?.productId,
        addOrRemoveLoading: true,
      };

    case BasketActionTypes.DECREMENT_ITEM_FROM_BASKET:
      return {
        ...state,
        productId: action?.data?.productId,
        addOrRemoveLoading: true,
      };

    case BasketActionTypes.REMOVE_ITEM_FROM_BASKET:
      return {
        ...state,
        productId: action?.data?.productId,
        addOrRemoveLoading: true,
      };

    case BasketActionTypes.SET_ADD_OR_REMOVE_LOADING:
      return {
        ...state,
        productId: undefined,
        addOrRemoveLoading: false,
      };

    case BasketActionTypes.FINALIZE_BASKET:
      return {
        ...state,
        storeBasketLoading: true,
      };

    case BasketActionTypes.SET_CLIENT_SUGGESTED_TYPE:
      return {
        ...state,
        clientSuggestedType: action?.data?.clientSuggestedType,
        clientSuggestedTime: undefined,
        clientSuggestedRange: undefined,
      };

    case BasketActionTypes.SET_CLIENT_SUGGESTED_TIME:
      return {
        ...state,
        clientSuggestedTime: action?.data?.clientSuggestedTime,
      };

    case BasketActionTypes.SET_CLIENT_SUGGESTED_RANGE:
      return {
        ...state,
        clientSuggestedRange: action?.data?.clientSuggestedRange,
      };

    case BasketActionTypes.SET_RECIPIENTS_LIST:
      return {
        ...state,
        recipients: {
          ...state.recipients,
          [action?.data?.id]: action?.data?.text,
        },
        recipientsValidation: action?.data?.recipientsValidation && !!action?.data?.text,
      };

    case BasketActionTypes.CHECK_DATA_VALIDATION:
      let recipientsError = false;

      for (const property in state.recipients) {
        // @ts-ignore
        if (!state.recipients[property]) {
          recipientsError = true;
          break;
        }
      }

      return {
        ...state,
        recipientsError: recipientsError,
        dataValidation: false,
      };

    case BasketActionTypes.SET_BASKET_LOADING:
      return {
        ...state,
        loading: action?.data?.loading,
      };

    default:
      return state;
  }
}

export default basketReducer;
